import React from 'react';
import PropTypes from 'prop-types';
import './ToolTipBar.scss';
import EditorPlain from '../EditorPlain/EditorPlain';
import Icon from '../Icon';

class ToolTipBar extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            isExpanded: false
        }
    }

    componentDidUpdate = (prevProps) => {
        // when changing pages we need to collapse
        if(prevProps.location.pathname != this.props.location.pathname) {
            this.setState({ isExpanded: false });
        }
    }

    onShowMore = () => {
        this.setState({ isExpanded: !this.state.isExpanded });
    }

    onRemindMeLater = () => {
        this.props.dismissCallback(false);
    }

    onDismiss = () => {
        this.props.dismissCallback(true);
    }

    render() {
        const jsonMessage = JSON.parse(this.props.toolTip.message);
        return (
            <div className="tooltipbar">
                <div className="alert alert-warning" role="alert">
                    <div className="title">
                        <Icon name="info-circle" /> {this.props.toolTip.title}
                        {!this.state.isExpanded ? 
                            <a href="#" className="alert-link" onClick={this.onShowMore}>Read more</a>
                            :
                            <a href="#" className="alert-link" onClick={this.onShowMore}>Minimize</a>
                        }
                        <a href="#" className="alert-link" onClick={this.onRemindMeLater}>Remind me later</a>
                        <a href="#" className="alert-link" onClick={this.onDismiss}>Don&apos;t show again</a>
                    </div>
                    {this.state.isExpanded &&
                        <div>
                            <div className="message">
                                <EditorPlain jsonMessage={jsonMessage} />
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

ToolTipBar.propTypes = {
    toolTip: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    dismissCallback: PropTypes.func.isRequired
};

export default ToolTipBar;
